import { useNotifications } from '@/hooks/Notifications/notifications';
import { useActionSheet } from '@hooks/actionSheet';
import React, { useCallback } from 'react';

import Main from './Main';
import { actionSheetNotificationsConfig } from './constants';

const NotificationsIcon: React.FC<{ isMobile?: boolean }> = ({ isMobile }) => {
  const { openActionSheet } = useActionSheet();
  const { pendingNotifications } = useNotifications();

  const onOpenNotifications = useCallback(() => {
    openActionSheet(actionSheetNotificationsConfig);
  }, [openActionSheet]);

  return (
    <Main
      onOpenNotifications={onOpenNotifications}
      hasOpenNotification={pendingNotifications > 0}
      isMobile={isMobile}
    />
  );
};

export default NotificationsIcon;
